module.exports = __webpack_public_path__ + "img/partner-tourismus-montafon_weiss.23ccb27a.svg";